import { HttpClient } from '@angular/common/http';
import { not } from '@angular/compiler/src/output/output_ast';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map, takeUntil } from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class GazetteService {
  URL = environment.iCBMSWebApi.url
  constructor(private httpClient:HttpClient) { }
  create(data){
    return this.httpClient.post(this.URL + 'RegulatoryEvent',data);
  }
  getAll(){
    return this.httpClient.get(this.URL + 'RegulatoryEvent');
  }
  deleteRegulatoryEvent(id){
    return this.httpClient.delete(this.URL + 'RegulatoryEvent/'+id);
  }
  getApplications(){
    return this.httpClient.get(this.URL + 'event/apps');
  }
  saveSelected(data,reg_event_id,name){
    return this.httpClient.post(this.URL + 'event/save/selected/'+reg_event_id+'/'+name,data);
  }
  getSelected(reg_event_id){
    return this.httpClient.get(this.URL + 'event/get/selected/'+reg_event_id);
  }
  createAdvert(reg_event_id){
    return this.httpClient.get(this.URL + 'create/advert/'+reg_event_id);
  }
  modifyAdvert(body){
    return this.httpClient.post(this.URL + 'modify/advert',body);
  }
  modifyGazette(body){
    return this.httpClient.post(this.URL + 'modify/gazette',body);
  }
  deleteRegulatoryApp(id){
    return this.httpClient.delete(this.URL + 'RegulatoryApplication/'+id);
  }
  downloadWord(fileName: any) {
    let body = {
      fileName:fileName
    }
    return this.httpClient
      .post(this.URL + "download/advert", body, { responseType: "blob" })
      .pipe(
        map((res: any) => {
          return new Blob([res], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
        })//http://localhost:58614/api/download/advert/
      );
  }
  checkGazette(body){
    return this.httpClient.post(this.URL + 'check/advert',body);
  }
  sendGazette(body){
    return this.httpClient.post(this.URL + 'send/advert',body);
  }
  
}
